import api from './api';

export const appointmentService = {
  // Dohvati sve termine
  getAllAppointments: async (page = 1, limit = 10, filters = {}) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    
    if (filters.status) params.append('status', filters.status);
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.append('dateTo', filters.dateTo);
    if (filters.clientName) params.append('clientName', filters.clientName);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);
    
    return await api.get(`/appointments?${params.toString()}`);
  },

  // Dohvati termin po ID-u
  getAppointmentById: async (id) => {
    return await api.get(`/appointments/${id}`);
  },

  // Kreiraj novi termin
  createAppointment: async (appointmentData) => {
    return await api.post('/appointments', appointmentData);
  },

  // Ažuriraj termin
  updateAppointment: async (id, appointmentData) => {
    return await api.put(`/appointments/${id}`, appointmentData);
  },

  // Obriši termin
  deleteAppointment: async (id) => {
    return await api.delete(`/appointments/${id}`);
  },

  // Dohvati termine po tenant-u
  getAppointmentsByTenant: async (tenantId, page = 1, limit = 10, filters = {}) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    
    if (filters.status) params.append('status', filters.status);
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.append('dateTo', filters.dateTo);
    if (filters.clientName) params.append('clientName', filters.clientName);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);
    
    return await api.get(`/appointments/tenant/${tenantId}?${params.toString()}`);
  },

  // Dohvati termine po korisniku
  getAppointmentsByCustomer: async (customerId, page = 1, limit = 10, tenantId = null, filters = {}) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    
    if (tenantId) params.append('tenantId', tenantId);
    if (filters.status) params.append('status', filters.status);
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.append('dateTo', filters.dateTo);
    if (filters.clientName) params.append('clientName', filters.clientName);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);
    
    return await api.get(`/appointments/customer/${customerId}?${params.toString()}`);
  },

  // Dohvati termine po zaposlenom
  getAppointmentsByEmployee: async (employeeId, page = 1, limit = 10, filters = {}) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    
    if (filters.status) params.append('status', filters.status);
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.append('dateTo', filters.dateTo);
    if (filters.clientName) params.append('clientName', filters.clientName);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);
    
    return await api.get(`/appointments/employee/${employeeId}?${params.toString()}`);
  },

  // Dohvati dostupne termine
  getAvailableSlots: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/appointments/available-slots?${queryString}`);
  },

  // Dohvati dostupne dane
  getAvailableDays: async (tenantId, params = {}) => {
    const queryParams = new URLSearchParams();
    queryParams.append('tenantId', tenantId);
    
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.duration) queryParams.append('duration', params.duration);
    if (params.employeeId) queryParams.append('employeeId', params.employeeId);
    
    const queryString = queryParams.toString();
    return await api.get(`/exceptions/available-days?${queryString}`);
  },

  // Dohvati dostupne slotove za određeni dan
  getAvailableSlotsForDate: async (tenantId, date, params = {}) => {
    const queryParams = new URLSearchParams();
    queryParams.append('tenantId', tenantId);
    queryParams.append('date', date);
    
    if (params.duration) queryParams.append('duration', params.duration);
    if (params.employeeId) queryParams.append('employeeId', params.employeeId);
    
    const queryString = queryParams.toString();
    return await api.get(`/exceptions/available-slots?${queryString}`);
  },

  // Ažuriraj status plaćanja
  updatePaymentStatus: async (id, paymentData) => {
    return await api.patch(`/appointments/${id}/payment`, paymentData);
  },

  // Potvrdi termin
  confirmAppointment: async (id) => {
    return await api.patch(`/appointments/${id}/confirm`);
  },

  // Otkaži termin
  cancelAppointment: async (id, cancellationReason = '') => {
    return await api.patch(`/appointments/${id}/cancel`, { cancellationReason });
  },

  // Postavi termin na čekanju
  setAppointmentPending: async (id) => {
    return await api.patch(`/appointments/${id}/pending`);
  },

  // Dohvati statistiku
  getAppointmentStats: async () => {
    return await api.get('/appointments/stats/overview');
  },

  getLastAndNextAppointment: async (customerId, tenantId) => { 
    const params = new URLSearchParams();
    params.append('customerId', customerId);
    params.append('tenantId', tenantId);
    return await api.get("/appointments/get-last-and-next-appointment?" + params.toString());
  },

  getStatistics: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/appointments/statistics?${queryString}`);
  },
};

export default appointmentService;

